// stores/userStore.js
import { defineStore } from "pinia";
import { useOnline } from "@vueuse/core";

export const useUserStore = defineStore("user_store", {
  persist: true,
  state: () => ({
    userData: {
      is_signed_in: false
    },
    session: {},
    userOnlineStatus: useOnline(),
    forceUserOffline: false
  }),
  getters: {
    getUserData: (state) => state.userData,
    isUserLoggedIn: (state) => state.userData["is_signed_in"] || false,
    isOnline: (state) =>
      state.forceUserOffline ? false : state.userOnlineStatus
  },
  actions: {
    setUserData(userData) {
      this.userData = {
        ...this.userData,
        ...userData
      };
    },
    getRefreshToken() {
      return this.session.refresh_token;
    },
    setUserSession(session) {
      this.session = {
        ...this.session,
        ...session
      };
    },
    setIsUserSignedIn(is_signed_in) {
      this.userData["is_signed_in"] = is_signed_in;
    },
    isUserSignedIn() {
      return this.userData["is_signed_in"] || false;
    }
  },
  $reset() {
    this.userData = {};
    this.session = {};
  }
});
